import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';

export let apolloCache: InMemoryCache;

export const initApolloCache = (fragmentMatcher: IntrospectionFragmentMatcher) => {
  apolloCache = new InMemoryCache({ fragmentMatcher });
  return apolloCache;
};
